(function($) {
	$(document).ready(function(){
		/*Locations page tabs*/
		$(".event-tab").on("click", function() {
			$(".event-tab").removeClass("event-tab-active");
			$(this).addClass("event-tab-active");
			var contentId = "#" + $(this).attr("id") + "-content";
			$(".event-tab-content").slideUp(400);
			$(contentId).delay(400).slideDown(400);
		});	
		
		//sidebar buttons
		$("#volunteer-here-button").on("click", function() {
			$(this).toggleClass("sidebar-button-active");
			$("#volunteer-here-button-dropdown").slideToggle(400);
		});
		
			
		window.setInterval(rotateTestimonial, 15000);
		
		// Mobile Testimonial Script
		$('.testi-wrapper.mobile img').click(function(){
			getTestimonial($(this).attr('rel'));
			$('.arrow-down').hide();
			$(this).addClass('selected').prev().show();
		});
		
		//Locations Gallery
//		$("#event-gallery-images").on("click", "img", function() {
//			var imageSrc = $(this).data("imodal");
//			var width = $(this).data("iwidth");
//			var height = $(this).data("iheight");
//			if(imageSrc === undefined) {
//			$("#modal-body").html("<h2>Image Not Found</h2>");
//			} else {
//			$("#modal-body").html("<img style='max-width: " + width + "px; max-height: " + height + "px;' class='modal-image' src='" + imageSrc + "' />");
//			}
//			$("#galleryModal").modal("show");
//		});
		
		//Events Infos Tab
		$('.mobile-events-tab a').on("click", function(e){
//			e.preventDefault();
//
//			$tab = $(this);
//			$content_attrib = $tab.attr('link');
//			$(".event-tab-content").slideUp(400);
//			$("#"+$content_attrib).delay(400).slideDown(400);
			e.preventDefault();

			$tab = $(this);
			$content_attrib = $tab.attr('link');	
			$content = $('#'+$content_attrib);
			$newDivId = $content_attrib+"new";			
			
			if(!$("#"+$newDivId).length){
				$pclass = $content.parent().attr('class');
				$wrapper = "<div id='"+$newDivId+"'class='"+$pclass+"'></div>";
				$(this).after($wrapper);		
				$("#"+$newDivId).append($content.clone()).slideToggle();
			} else {
				$("#"+$newDivId).slideToggle();
			}
		});
		
		// Select State Dropdown
		$("#home_select_state").on("click", function(e) {
			e.preventDefault();
			$(this).toggleClass("gallery-city-button-active");
			$("#gallery-city-dropdown").slideToggle(400);
		});
		
		// When user select specific state on dropdown
		$('#home_select_state').find('.gallery-city-dropdown li').click(function(){
			$state = $(this).attr('data-city');
			$('.state_content_wrapper').children('.tour-dates-block').find('a').hide();
			$('.tour-dates-block').find("[state_id='"+$state+"']").fadeIn();
		});		
		
		//See More
		x = 5;
		$('.see_more a').on("click", function(e){
			e.preventDefault();
			size_a = $('.upcoming_content').find('a').size();
			x = (x+5 <= size_a) ? x+5 : size_a;
			$('.upcoming_content').find('.tour-dates-block a:lt('+x+')').fadeIn('slow');
		});
		
		//Sort/Filter Click homepage
		$('.tour-dates-sort a').click(function(e){
			$('.tour-dates-sort a').attr('class','');
			$(this).attr('class','sort-active');
			$target_id = $(this).attr('rel');
			$('.filter_tabs').fadeOut();
			$('#'+$target_id).fadeIn('slow');			
			e.preventDefault();
		});	
		
		var tag = $('#ajax-image-param').text();
		var data = {
		  'action': 'gallery_query_images',
		  'post_type': 'post',
		  'tag': tag,
		  'offset': 0,
		  'triggeredBy': 'onPageLoad'
		};
		var ajax_url = "/wp-admin/admin-ajax.php";
		var replace = false;
		var offset = 0;
		var loadImageCount = 12;
		var noImagesFlag = false;

		// $('#event-gallery-images').imagesLoaded( function() {
			// setTimeout(function(){
				// $('#event-gallery-images').masonry({
					// itemSelector: '.grid-item'
				// });
			// },1000);
		// });
		
//		$('#event-photos-tab').on('click', function(){
//			$('#event-gallery-images').css('visibility', 'hidden');
//			setTimeout(function(){
//				$('#event-gallery-images').masonry({
//					itemSelector: '.grid-item'
//				});
//				$('#event-gallery-images').css('visibility', 'visible');
//			},1500);   
//		});


		// function loadEventGalleryImages(images) {
			// if(replace === true) {
				// $("#event-gallery-images").html('');
				// replace = false;
			// }

			// for(var img = 0; img < images.length; img++) {
				// imageData = "<div class='grid-item' data-category='"+images[img].category+"'><img src='" + images[img].url + "' data-imodal='" + images[img].url + "' data-iheight='" + images[img].height + "' data-iwidth='" + images[img].width + "'/></div>"; 
				// $("#event-gallery-images").append(imageData);
			// }   
		// }

		// function imageAjax() {
			// $.post( ajax_url, data, function(response) {
				// if(response.status === false) {
					// if(noImagesFlag === false) {
					 // $("#gallery-message").html("<h1>" + response.message + "</h1>");
					 // noImagesFlag = true;
					// }
				// } else {
					// loadEventGalleryImages(response.images);
				// }
			// }, 'json');
		// }
		
		// imageAjax();
		 
		// $("#event-gallery-see-more").on("click", function() {
			// offset = offset + loadImageCount;
			// data.offset = offset;
			// data.triggeredBy = 'see-more';
			// imageAjax();
		// });
		
		

	});
})(jQuery);

function joinTheVipList(location, country)
{
	var parts = location.split(", ");
	document.location = '/vip-list/?city='+country+':'+parts[1]+':'+parts[0];
}

$testimonialCount = 1;

function rotateTestimonial()
{
	$testimonialCount = ($testimonialCount < 5) ? $testimonialCount + 1 : 1;
	getTestimonial($testimonialCount);
}

function getTestimonial(num)
{
	var count = 1;
	$(".testimonial-circles-image").each(function () {
		$(this).removeClass('selected');
		
		if (count === num)
		{			
			$('.arrow-down').hide();
			$(this).addClass('selected');
			$(this).prev().show();
		}
		count++;
	});
	
	$(".bubble-content").each(function () {
		$(this).removeClass('selected');
	});	
	
	//console.log($(this));	
	$('.testimonial'+num).addClass('selected');	
}